var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.multiple
    ? _c(
        "el-upload",
        {
          ref: "upload",
          class: { upload_disabled: _vm.disabled },
          attrs: {
            action: "#",
            "on-error": _vm.uploadError,
            "show-file-list": false,
            multiple: "",
            "auto-upload": false,
            disabled: _vm.disabled,
            "on-change": function (file, fileList) {
              return _vm.changeFileList(file, fileList)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "upload_btn", class: _vm.showSvg ? "" : "pd0" },
            [
              _vm.showSvg
                ? _c("svg-icon", { attrs: { "icon-class": "upload" } })
                : _vm._e(),
              _c(
                "span",
                { staticClass: "name", class: _vm.showSvg ? "" : "pd0" },
                [_vm._v(_vm._s(_vm.btnName))]
              ),
            ],
            1
          ),
        ]
      )
    : _c(
        "el-upload",
        {
          ref: "upload",
          class: { upload_disabled: _vm.disabled },
          attrs: {
            action: "#",
            headers: _vm.headers,
            "on-error": _vm.uploadError,
            "on-success": _vm.uploadSuccess,
            "show-file-list": false,
            data: _vm.paramsData,
            disabled: _vm.disabled,
            "auto-upload": false,
            "before-upload": _vm.beforeUpload,
            "on-change": function (file, fileList) {
              return _vm.changeFileList(file, fileList)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "upload_btn", class: _vm.showSvg ? "" : "pd0" },
            [
              _vm.showSvg
                ? _c("svg-icon", { attrs: { "icon-class": "upload" } })
                : _vm._e(),
              _c(
                "span",
                { staticClass: "name", class: _vm.showSvg ? "" : "pd0" },
                [_vm._v(_vm._s(_vm.btnName))]
              ),
            ],
            1
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }